import {
  CORE_LOAD_ORDERS_REQUEST,
  CORE_LOAD_ORDERS_SUCCESS,

  // CORE_DELETE_ORDER_REQUEST,
  // CORE_DELETE_ORDER_SUCCESS,

  CORE_LOAD_ORDER_INFO_REQUEST,
  CORE_LOAD_ORDER_INFO_SUCCESS,
} from '../../types'

const initialState = []

export default {
  orders: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ORDERS_REQUEST:
        return initialState
      case CORE_LOAD_ORDERS_SUCCESS:
        if (action.payload[0]) {
          let payload = action.payload[0]
          let orders = []
          for (let i = 1; i <= payload.length; i++) {
            orders.push({ no: i, ...payload[i - 1] })
          }
          return orders
        }
        else return []

      default:
        return state
    }
  },
  orderInfo: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_ORDER_INFO_REQUEST:
        return {}
      case CORE_LOAD_ORDER_INFO_SUCCESS:
        return action.payload
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/orders/reducer.js